/**
 * W1 — 선언형 action rule table (imperative if 금지)
 */

import { ROLES } from '@shared/types/roles';
import type { ActionRuleEntry } from './action-types';

export const CORE_ACTION_RULE_TABLE: readonly ActionRuleEntry[] = [
  {
    condition: { domains: '*', roles: '*', statuses: '*', planes: ['business'] },
    actions: [
      {
        id: 'view',
        label: '상세 보기',
        priority: 100,
        surfaces: ['table-row', 'detail-header', 'command'],
        handlerRef: 'crud:view',
        permissionKey: 'read',
      },
      {
        id: 'edit',
        label: '수정',
        priority: 90,
        surfaces: ['table-row', 'detail-header', 'inspector', 'command'],
        handlerRef: 'crud:edit',
        permissionKey: 'update',
      },
      {
        id: 'delete',
        label: '삭제',
        priority: 10,
        surfaces: ['table-row', 'detail-header', 'command'],
        handlerRef: 'crud:delete',
        permissionKey: 'delete',
      },
      {
        id: 'copy-object-id',
        label: 'ID 복사',
        priority: 45,
        surfaces: ['table-row', 'inspector', 'command'],
        handlerRef: 'clipboard:copy-id',
        permissionKey: 'read',
      },
      {
        id: 'view-related-records',
        label: '관련 보기',
        priority: 42,
        surfaces: ['table-row', 'inspector', 'command'],
        handlerRef: 'navigate:related',
        group: 'attach',
        permissionKey: 'read',
      },
      {
        id: 'view-audit-trail',
        label: '감사 기록',
        priority: 38,
        surfaces: ['table-row', 'inspector', 'command'],
        handlerRef: 'navigate:audit',
        group: 'admin',
        permissionKey: 'read',
      },
    ],
  },
  {
    condition: {
      domains: '*',
      roles: [ROLES.OWNER, ROLES.OPERATIONS_MANAGER],
      statuses: '*',
      planes: ['business'],
    },
    actions: [
      {
        id: 'duplicate',
        label: '복제',
        priority: 50,
        surfaces: ['table-row', 'command'],
        handlerRef: 'crud:duplicate',
        permissionKey: 'create',
      },
    ],
  },
  {
    condition: { domains: '*', roles: '*', statuses: ['archived'], planes: ['business'] },
    actions: [
      {
        id: 'restore',
        label: '복원',
        priority: 80,
        surfaces: ['detail-header', 'command'],
        handlerRef: 'crud:restore',
        permissionKey: 'update',
      },
    ],
  },
  {
    condition: { domains: '*', roles: '*', statuses: '*', planes: ['business'] },
    actions: [
      {
        id: 'assignment-view-operation',
        label: '상세 보기',
        priority: 100,
        surfaces: ['assignment-board'],
        handlerRef: 'assignment:view-operation',
        permissionKey: 'flow:read',
      },
      {
        id: 'assignment-complete',
        label: '완료',
        priority: 80,
        surfaces: ['assignment-board'],
        handlerRef: 'assignment:complete',
        permissionKey: 'flow:complete',
      },
    ],
  },
  {
    condition: {
      domains: '*',
      roles: [ROLES.OWNER, ROLES.OPERATIONS_MANAGER],
      statuses: '*',
      planes: ['business'],
    },
    actions: [
      {
        id: 'assignment-assign',
        label: '배정',
        priority: 90,
        surfaces: ['assignment-board'],
        handlerRef: 'assignment:assign',
        permissionKey: 'flow:execute',
      },
      {
        id: 'assignment-reassign',
        label: '재배정',
        priority: 85,
        surfaces: ['assignment-board'],
        handlerRef: 'assignment:reassign',
        permissionKey: 'flow:execute',
      },
      {
        id: 'assignment-recommend',
        label: '추천 배정',
        priority: 70,
        surfaces: ['assignment-board'],
        handlerRef: 'assignment:recommend',
        permissionKey: 'flow:execute',
      },
    ],
  },
  {
    condition: { domains: '*', roles: '*', statuses: '*', planes: ['business'] },
    actions: [
      {
        id: 'my-tasks-process',
        label: '처리',
        priority: 100,
        surfaces: ['my-tasks'],
        handlerRef: 'my-tasks:process',
        permissionKey: 'flow:execute',
      },
      {
        id: 'my-tasks-view-flow',
        label: 'Flow',
        priority: 50,
        surfaces: ['my-tasks'],
        handlerRef: 'my-tasks:view-flow',
        permissionKey: 'flow:read',
      },
    ],
  },
] as const;
